import ChartingMenu from './ChartingMenu';
export default ChartingMenu;